import { RadioButton, RadioButtonTrueFalse } from "Components/Form/RadioButton";

import { StyledAlert } from "App/global-style";
import { AccessibleCallUsMessage } from "Components/Form/AccessibleCallUsMessage";
import { AlertType, AlertWithIllustration } from "Components/Form/Alert";
import { getYesOrNoOptions } from "Components/Form/RadioButton/radioButtonUtils";
import { useTexts } from "Components/TextContext";
import { OptionLabel } from "Components/TextContext/commonComponentEnums";
import { IllustrationName } from "Constants/constants";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { AkaHealthProductIntroFormValues } from "./akaHealthProductIntroInterfaces";

interface Props {
  formProps: FormikProps<AkaHealthProductIntroFormValues>;
}

export const AkaHealthProductIntroFormElements = ({
  formProps,
}: Props): React.ReactElement => {
  const { getText } = useTexts();
  return (
    <>
      <RadioButtonTrueFalse
        name="isMemberOfNordicSocialSecurity"
        id="isMemberOfNordicSocialSecurity"
        label={getText("akahealthform.label.ismemberofnordicsocialsecurity")}
        options={getYesOrNoOptions("yes", "no")}
        direction="vertical"
        error={getError("isMemberOfNordicSocialSecurity", formProps)}
      />
      {formProps.values.isMemberOfNordicSocialSecurity ===
        BooleanFormType.FALSE && (
        <StyledAlert
          title={getText(
            "akahealthform.alerttitle.ismemberofnordicsocialsecurity",
          )}
          description={getText(
            "akahealthform.alertdescription.ismemberofnordicsocialsecurity",
          )}
          type="error"
          fluid
          alertId="isMemberOfNordicSocialSecurity"
          alertType={AlertType.STOPPER_ALERT}
        />
      )}

      <RadioButton
        name="isCoInsured"
        id="isCoInsured"
        label={getText("akahealthform.label.iscoinsured")}
        options={[
          {
            label: getText(OptionLabel.BOOLEAN_YES),
            value: BooleanFormType.TRUE,
            id: "coinsured_yes",
          },
          {
            label: getText(OptionLabel.BOOLEAN_NO),
            value: BooleanFormType.FALSE,
            id: "coinsured_no",
          },
        ]}
        direction="vertical"
        error={getError("isCoInsured", formProps)}
      />
      {formProps.values.isCoInsured === BooleanFormType.TRUE && (
        <AlertWithIllustration
          title={getText("akahealthform.alerttitle.iscoinsured")}
          illustrationName={IllustrationName.CUSTOMER_SERVICE_WOMAN}
          marginBottom="32px"
        >
          <AccessibleCallUsMessage />
        </AlertWithIllustration>
      )}
    </>
  );
};
